import { toast } from "react-toastify";

import NProgress from 'nprogress';
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";

// --- Employee Asset Helpers ---

export const GetEmployeeClearanceHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getEmployeeClearance`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            from_date: params?.from_date,
            to_date: params?.to_date,
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Assets retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve employee asset", hasError: true, data: err?.response?.data }
    });
};

export const AddEmployeeClearanceHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/employee/addEmployeeClearance`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            from_date: params?.from_date,
            to_date: params?.to_date,
            record_date: params?.record_date,
            comment: params?.comment || "",
            clearance_type_configuration_fk: params?.clearance_type_configuration_fk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Asset assigned successfully");
        return { message: "Asset assigned successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to assign asset", hasError: true, data: err?.response?.data }
    });
};

export const UpdateEmployeeClearanceHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/employee/updateEmployeeClearance`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            from_date: params?.from_date,
            to_date: params?.to_date,
            record_date: params?.record_date,
            comment: params?.comment || "",
            clearance_type_configuration_fk: params?.clearance_type_configuration_fk,
            employee_clearance_mapping_id: +params?.employee_clearance_mapping_id,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Asset updated successfully");
        return { message: "Asset updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update asset", hasError: true, data: err?.response?.data }
    });
};

export const DeleteEmployeeClearanceHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/ecms/employee/deleteEmployeeClearance`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_clearance_mapping_id: +params?.employee_clearance_mapping_id,
            from_date: params?.from_date,
            to_date: params?.to_date,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Asset removed successfully");
        return { message: "Asset removed successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to remove asset", hasError: true, data: err?.response?.data }
    });
};

export const UpdateApprovedEmployeeAdjustmentClearanceHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/employee/updateApprovedEmployeeAdjustmentClearance`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            ecms_adjustment_agg_component_json: params?.ecms_adjustment_agg_component_json
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Assets clearance updated successfully");
        return { message: "Assets updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update asset clearance", hasError: true, data: err?.response?.data }
    });
};

export const UpdateApprovedEmployeeAssetsClearanceHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/employee/updateApprovedEmployeeAssetsClearance`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            clearance_agg_component_json : params?.clearance_agg_component_json
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustments clearance updated successfully");
        return { message: "Adjustments clearance updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update adjustment clearance", hasError: true, data: err?.response?.data }
    });
};
